import { Contact } from "src/api-service";
import { AppError } from "../../app-store-error.types";
import { DEFAULT_CONTACT_LIST_VISIBLE_COLUMNS } from "src/app/pages/home/page/contacts/components/contacts-table/contacts.columns";

// **************************************************************************
// CONTACT STATE
// **************************************************************************
export interface ContactState {
    contact: Contact | null;
    contacts: Contact[];
    // List UI state
    loaded: boolean;
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    sortProperty: string;
    sortAscending: boolean;
    searchFilter: string;
    visibleColumns: string[];
    // Loading
    loadingList: boolean;
    loadingDetail: boolean;
    creating: boolean;
    syncingFromAttio: boolean;
    // Error
    error: AppError | null;
}

export const initialContactState: ContactState = {
    contact: null,
    contacts: [],
    // List UI state
    loaded: false,
    pageNumber: 1,
    pageSize: 50,
    totalCount: 0,
    sortProperty: "created",
    sortAscending: false,
    searchFilter: "",
    visibleColumns: DEFAULT_CONTACT_LIST_VISIBLE_COLUMNS,
    // Loading
    loadingList: false,
    loadingDetail: false,
    creating: false,
    syncingFromAttio: false,
    // Error
    error: null,
};
